// @material-ui
import { makeStyles } from '@material-ui/styles'

export const serviceListStyle = theme => ({
  paging: {
    margin: theme.spacing(2, 0),
  },

  pagingUl: {
    justifyContent: 'center',
  },

  crumbs: {
    paddingBottom: theme.spacing(2),
  },
})

export const useServiceListStyle = makeStyles(serviceListStyle)
